// Holds the current tokens in module-level variables so the non-React API
// client can attach them as headers without depending on React context.
// AuthProvider keeps these in sync with the OIDC session.

let accessToken: string | null = null;
let idToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

// The ID token carries the profile claims (email/name) that access tokens do
// not; the backend needs it (X-Id-Token) to provision a user on first login.
export function setIdToken(token: string | null): void {
  idToken = token;
}

export function getIdToken(): string | null {
  return idToken;
}
